export default {
  defaults: require('./default').default,
  'sdyx-mzvip': require('./sdyx-mzvip').default,
}
